import { render } from "./PrefixHeader.vue?vue&type=template&id=ab1f88c2&scoped=true"
import script from "./PrefixHeader.vue?vue&type=script&lang=js"
export * from "./PrefixHeader.vue?vue&type=script&lang=js"

import "./PrefixHeader.vue?vue&type=style&index=0&id=ab1f88c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab1f88c2"]])

export default __exports__